import { Group } from '@antv/g';
// A empty component to pass parse view tree stage.
export const Legends = (options) => {
    return () => {
        return new Group();
    };
};
Legends.props = {};
//# sourceMappingURL=legends.js.map